// extracted by mini-css-extract-plugin
export default {"featuredProductBox":"FeaturedProducts_featuredProductBox__mVGkA","availSizeTitle":"FeaturedProducts_availSizeTitle__Mtian","smallTitle":"FeaturedProducts_smallTitle__Wqpih"};